import { useState } from 'react';
import ExoForm from '../ExoForm';
import * as Yup from 'yup';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../../api/api';
import { useTranslation } from 'react-i18next';

export const NewMatchingPropertyText = ({
  onUpdate,
  onCreate,
  startData,
  onClose,
  onFeedback,
  salesLevelId,
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [isLoading, setIsLoading] = useState(false);

  const fields = [
    {
      label: t('Label'),
      type: 'text',
      key: 'label',
    },
    {
      label: t('Save in library'),
      key: 'isGlobal',
      type: 'checkbox',
    },
    {
      label: t('Will be shared with seller.'),
      key: 'isShareable',
      type: 'checkbox',
    },
  ];

  const validationSchema = Yup.object().shape({
    label: Yup.string().required(t('Is required')),
  });

  function handleSubmit(data) {
    const isUpdate = Boolean(data.id);
    DBRequest({
      config,
      path: isUpdate
        ? `sales-object-properties/${data.id}`
        : `sales-object-properties`,
      method: isUpdate
        ? API_PATCH(data)
        : API_POST({ ...data, salesLevelId, type: 'text' }),
      onResponse: isUpdate ? onUpdate : onCreate,
      onLoading: setIsLoading,
    });
  }

  return (
    <ExoForm
      fields={fields}
      startDataCollection={startData || { comparativeBehavior: 'diff' }}
      onSubmit={handleSubmit}
      onCancel={onClose}
      isLoading={isLoading}
      validationSchema={validationSchema}
      noDifferences
    />
  );
};
